(function () {
  "use strict";
  var FREE = (window.CCTheme && window.CCTheme.freeShip) || 15000;

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, "");
    return "$" + v;
  }

  function moneyAud(cents) {
    return money(cents) + " AUD";
  }

  /* ---------- nav + mobile menu ---------- */
  var nav = document.getElementById("nav");
  if (nav) {
    var onScroll = function () { nav.classList.toggle("scrolled", window.scrollY > 40); };
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  }

  var menuToggle = document.getElementById("menuToggle");
  var menuClose = document.getElementById("menuClose");
  var menuBackdrop = document.getElementById("menuBackdrop");
  var mobileMenu = document.getElementById("mobileMenu");

  function setMenuOpen(open) {
    if (!mobileMenu) return;
    if (open && typeof closeCart === "function") closeCart();
    mobileMenu.classList.toggle("open", open);
    document.body.classList.toggle("menu-open", open);
    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", String(open));
      menuToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    }
    mobileMenu.setAttribute("aria-hidden", String(!open));
    if (open && menuClose) menuClose.focus();
    if (!open && menuToggle) menuToggle.focus();
  }

  function closeMenu() { setMenuOpen(false); }
  function toggleMenu() { setMenuOpen(!mobileMenu.classList.contains("open")); }

  menuToggle && menuToggle.addEventListener("click", toggleMenu);
  menuClose && menuClose.addEventListener("click", closeMenu);
  menuBackdrop && menuBackdrop.addEventListener("click", closeMenu);
  mobileMenu && mobileMenu.querySelectorAll("a").forEach(function (link) {
    link.addEventListener("click", closeMenu);
  });

  /* ---------- cart drawer (Shopify AJAX) ---------- */
  var drawer = document.getElementById("cartDrawer"),
      overlay = document.getElementById("cartOverlay"),
      itemsEl = document.getElementById("cartItems"),
      countEl = document.getElementById("cartCount"),
      subEl = document.getElementById("cartSubtotal"),
      qtyLabel = document.getElementById("cartQtyLabel"),
      shipMsg = document.getElementById("shipMsg"),
      shipFill = document.getElementById("shipFill"),
      emptyTpl = document.getElementById("cartEmptyTemplate");

  function openCart() {
    closeMenu();
    if (!drawer) return;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    overlay && overlay.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    overlay && overlay.classList.remove("open");
    document.body.style.overflow = "";
  }

  function variantLabel(it) {
    if (!it.variant_title || it.variant_title === "Default Title" || it.variant_title === "One Size") return "";
    return " · " + it.variant_title;
  }

  function renderCartItem(it) {
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_160x$1$2") : "";
    return '<div class="cart-item" data-key="' + it.key + '">'
      + '<div class="cart-item-img">' + (img ? '<img src="' + img + '" alt="' + (it.product_title || "").replace(/"/g, "&quot;") + '">' : "") + '</div>'
      + '<div class="cart-item-meta">'
      + '<div class="cart-item-name">' + it.product_title + variantLabel(it) + '</div>'
      + '<div class="cart-item-price">' + moneyAud(it.price) + '</div>'
      + '<div class="qty-row">'
      + '<button class="qty-btn" type="button" data-dec aria-label="Decrease quantity">−</button>'
      + '<span class="qty-val">' + it.quantity + '</span>'
      + '<button class="qty-btn" type="button" data-inc aria-label="Increase quantity">+</button>'
      + '<button class="cart-item-remove" type="button" data-remove>Remove</button>'
      + '</div></div>'
      + '<div class="cart-item-line">' + money(it.final_line_price) + '</div>'
      + '</div>';
  }

  function renderCart(cart) {
    if (!drawer) return;
    countEl && (countEl.textContent = cart.item_count);
    if (qtyLabel) {
      qtyLabel.textContent = cart.item_count
        ? "(" + cart.item_count + " ITEM" + (cart.item_count > 1 ? "S" : "") + ")"
        : "";
    }
    subEl && (subEl.textContent = money(cart.items_subtotal_price));
    if (!cart.item_count) {
      itemsEl.innerHTML = emptyTpl ? emptyTpl.innerHTML : '<div class="cart-empty">Your cart is empty.</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(renderCartItem).join("");
    }
    var pct = Math.min(100, (cart.items_subtotal_price / FREE) * 100);
    if (shipFill) {
      shipFill.style.width = pct + "%";
      shipFill.classList.toggle("free", cart.items_subtotal_price >= FREE);
    }
    if (shipMsg) {
      shipMsg.innerHTML = cart.items_subtotal_price >= FREE
        ? "<b>You\u2019ve unlocked free shipping!</b>"
        : "You\u2019re <b>" + money(FREE - cart.items_subtotal_price) + "</b> away from free Australia-wide shipping.";
    }
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw r;
      return fetchCart();
    }).then(openCart);
  }

  function changeQty(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.getElementById("cartBtn") && document.getElementById("cartBtn").addEventListener("click", function () {
    fetchCart().then(openCart);
  });
  document.getElementById("cartClose") && document.getElementById("cartClose").addEventListener("click", closeCart);
  overlay && overlay.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeMenu();
      closeCart();
      document.querySelectorAll(".qa-wrap.open").forEach(function (w) { w.classList.remove("open"); });
    }
  });

  document.addEventListener("click", function (e) {
    var t = e.target;
    var item = t.closest && t.closest(".cart-item");
    if (item) {
      var key = item.getAttribute("data-key");
      var qty = parseInt(item.querySelector(".qty-val").textContent, 10);
      if (t.closest("[data-inc]")) return changeQty(key, qty + 1);
      if (t.closest("[data-dec]")) return changeQty(key, Math.max(0, qty - 1));
      if (t.closest("[data-remove]")) return changeQty(key, 0);
    }
    /* quick add */
    var qa = t.closest && t.closest("[data-quickadd]");
    if (qa) {
      var wrap = qa.closest(".qa-wrap");
      var sizes = wrap.querySelectorAll(".qa-size");
      if (sizes.length === 1) {
        addToCart(sizes[0].getAttribute("data-variant"), 1);
        qa.classList.add("added"); qa.textContent = "Added ✓";
        setTimeout(function () { qa.classList.remove("added"); qa.textContent = qa.getAttribute("data-label") || "Add to Cart"; }, 1200);
      } else {
        document.querySelectorAll(".qa-wrap.open").forEach(function (w) { if (w !== wrap) w.classList.remove("open"); });
        wrap.classList.toggle("open");
      }
      return;
    }
    var qs = t.closest && t.closest(".qa-size");
    if (qs && !qs.disabled) {
      var w2 = qs.closest(".qa-wrap"); w2.classList.remove("open");
      var btn = w2.querySelector("[data-quickadd]");
      addToCart(qs.getAttribute("data-variant"), 1);
      if (btn) { btn.classList.add("added"); btn.textContent = "Added ✓"; setTimeout(function () { btn.classList.remove("added"); btn.textContent = btn.getAttribute("data-label") || "Add to Cart"; }, 1200); }
      return;
    }
    if (!t.closest(".qa-wrap")) document.querySelectorAll(".qa-wrap.open").forEach(function (w) { w.classList.remove("open"); });
  });

  /* ---------- product page ---------- */
  var pdp = document.getElementById("pdp");
  if (pdp) {
    var payload = JSON.parse(document.getElementById("pdpVariants").textContent);
    var optionNames = payload.options || [];
    var variants = payload.variants || payload;
    var priceEl = document.getElementById("pdpPrice");
    var installmentEl = document.getElementById("pdpInstallment");
    var addBtn = document.getElementById("pdpAdd");
    var buyBtn = document.getElementById("pdpBuy");
    var variantInput = document.getElementById("pdpVariantId");
    var colorLabel = document.getElementById("pdpColorLabel");
    var mainImg = document.getElementById("pdpMainImg");
    var selected = [];
    var current = null;

    function optionIndex(name) {
      var target = String(name).toLowerCase();
      return optionNames.findIndex(function (n) {
        var d = String(n).toLowerCase();
        if (target === "colour" || target === "color") return d === "colour" || d === "color" || d === "coloris";
        return d === target;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function findFallback(opts) {
      var exact = findVariant(opts);
      if (exact) return exact;
      return variants.find(function (v) {
        return opts.every(function (o, i) { return !o || v.options[i] === o; }) && v.available;
      }) || variants.find(function (v) { return v.available; }) || variants[0];
    }

    function syncOptionUi() {
      optionNames.forEach(function (_, index) {
        var group = pdp.querySelector('[data-option-index="' + index + '"]');
        if (!group) return;
        group.querySelectorAll("[data-value]").forEach(function (btn) {
          var on = btn.getAttribute("data-value") === selected[index];
          btn.classList.toggle("cur", on);
          btn.setAttribute("aria-pressed", on ? "true" : "false");
        });
      });
      if (colorLabel) {
        var ci = optionIndex("colour");
        if (ci > -1) colorLabel.textContent = selected[ci] || "";
      }
      pdp.querySelectorAll("[data-option-position][data-value]").forEach(function (btn) {
        var pos = Number(btn.getAttribute("data-option-position")) - 1;
        var value = btn.getAttribute("data-value");
        var available;
        if (btn.classList.contains("swatch")) {
          available = variants.some(function (v) {
            return v.options[pos] === value && v.available;
          });
          btn.style.opacity = available ? "" : "0.35";
        } else {
          var trial = selected.slice();
          trial[pos] = value;
          var match = findVariant(trial);
          available = !!(match && match.available);
        }
        btn.disabled = !available;
      });
    }

    function selectVariant(v) {
      if (!v) return;
      current = v;
      selected = v.options.slice();
      syncOptionUi();
      if (priceEl) priceEl.textContent = money(v.price);
      if (installmentEl) installmentEl.textContent = money(Math.round(v.price / 4));
      if (variantInput) variantInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available
          ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 8h12l-1 12H7L6 8z" stroke-linejoin="round"/><path d="M9 8V6a3 3 0 0 1 6 0v2" stroke-linecap="round"/></svg> Add to cart'
          : "Sold out";
      }
      if (buyBtn) buyBtn.disabled = !v.available;
      if (v.featured_image && mainImg) mainImg.src = v.featured_image;
      try { history.replaceState(null, "", "?variant=" + v.id); } catch (err) {}
    }

    pdp.querySelectorAll("[data-option-position][data-value]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.disabled) return;
        var pos = Number(btn.getAttribute("data-option-position")) - 1;
        var next = selected.slice();
        next[pos] = btn.getAttribute("data-value");
        selectVariant(findFallback(next));
      });
    });

    var urlV = new URLSearchParams(location.search).get("variant");
    if (urlV) current = variants.find(function (x) { return String(x.id) === urlV; });
    if (!current) current = variants.find(function (v) { return v.available; }) || variants[0];
    selectVariant(current);

    addBtn && addBtn.addEventListener("click", function () {
      if (!current || !current.available || addBtn.disabled) return;
      addBtn.disabled = true;
      addToCart(current.id, 1)
        .then(function () {
          addBtn.textContent = "Added ✓";
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 8h12l-1 12H7L6 8z" stroke-linejoin="round"/><path d="M9 8V6a3 3 0 0 1 6 0v2" stroke-linecap="round"/></svg> Add to cart';
          }, 1200);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = "Try again";
        });
    });

    buyBtn && buyBtn.addEventListener("click", function () {
      if (!current || !current.available) return;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(current.id), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw r;
        window.location.href = "/checkout";
      });
    });

    pdp.querySelectorAll("#pdpThumbs button, .thumbs button").forEach(function (b) {
      b.addEventListener("click", function () {
        if (mainImg) mainImg.src = b.getAttribute("data-full");
        pdp.querySelectorAll("#pdpThumbs button, .thumbs button").forEach(function (x) { x.classList.remove("cur"); });
        b.classList.add("cur");
      });
    });

    var tabs = document.getElementById("pdpTabs");
    if (tabs) {
      tabs.querySelectorAll("[data-tab]").forEach(function (tab) {
        tab.addEventListener("click", function () {
          var id = tab.getAttribute("data-tab");
          tabs.querySelectorAll("[data-tab]").forEach(function (t) {
            var on = t === tab;
            t.classList.toggle("cur", on);
            t.setAttribute("aria-selected", on ? "true" : "false");
          });
          tabs.querySelectorAll("[data-panel]").forEach(function (panel) {
            var on = panel.getAttribute("data-panel") === id;
            panel.classList.toggle("on", on);
            panel.hidden = !on;
          });
        });
      });
    }
  }

  /* ---------- featured carousel ---------- */
  var track = document.getElementById("track");
  if (track) {
    var prev = document.getElementById("prev"), next = document.getElementById("next"),
        dots = document.getElementById("dots");
    var step = function () { var c = track.querySelector(".prod"); return c ? c.getBoundingClientRect().width + 22 : 320; };
    prev && prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    next && next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    if (dots) {
      var cards = track.querySelectorAll(".prod").length;
      for (var i = 0; i < cards; i++) { var d = document.createElement("span"); d.className = "dot" + (i === 0 ? " active" : ""); dots.appendChild(d); }
      var ds = dots.querySelectorAll(".dot");
      track.addEventListener("scroll", function () {
        var idx = Math.min(ds.length - 1, Math.round(track.scrollLeft / step()));
        ds.forEach(function (d, j) { d.classList.toggle("active", j === idx); });
      }, { passive: true });
    }
  }

  /* ---------- reveal on scroll ---------- */
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!reduceMotion && "IntersectionObserver" in window) {
    var revealIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          revealIo.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });
    document.querySelectorAll(".reveal").forEach(function (el) { revealIo.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- collection sort + filter drawer ---------- */
  var sortForm = document.getElementById("CollectionSort");
  if (sortForm) {
    var sortSelect = sortForm.querySelector("#SortBy");
    sortSelect && sortSelect.addEventListener("change", function () { sortForm.submit(); });
  }
  var sortFormMobile = document.getElementById("CollectionSortMobile");
  if (sortFormMobile) {
    var sortSelectMobile = sortFormMobile.querySelector("#SortByMobile");
    sortSelectMobile && sortSelectMobile.addEventListener("change", function () { sortFormMobile.submit(); });
  }

  var filterForm = document.getElementById("CollectionFilters");
  if (filterForm) {
    filterForm.addEventListener("change", function () { filterForm.submit(); });
  }

  var filterToggle = document.getElementById("filterToggle");
  var filterClose = document.getElementById("filterClose");
  var filterOverlay = document.getElementById("filterOverlay");
  var filterDrawer = document.getElementById("filterDrawer");

  function setFilterOpen(open) {
    if (!filterDrawer) return;
    var isMobile = window.matchMedia("(max-width: 820px)").matches;
    if (!isMobile) open = false;
    filterDrawer.classList.toggle("open", open);
    if (isMobile) {
      filterDrawer.setAttribute("aria-hidden", String(!open));
    } else {
      filterDrawer.removeAttribute("aria-hidden");
    }
    filterOverlay && filterOverlay.classList.toggle("open", open);
    document.body.classList.toggle("filters-open", open);
    if (filterToggle) {
      filterToggle.setAttribute("aria-expanded", String(open));
      filterToggle.setAttribute("aria-label", open ? "Close filters" : "Open filters");
    }
    if (open && filterClose) filterClose.focus();
  }

  function closeFilters() { setFilterOpen(false); }

  if (filterDrawer && window.matchMedia("(max-width: 820px)").matches) {
    filterDrawer.setAttribute("aria-hidden", "true");
  }

  filterToggle && filterToggle.addEventListener("click", function () {
    setFilterOpen(!filterDrawer.classList.contains("open"));
  });
  filterClose && filterClose.addEventListener("click", closeFilters);
  filterOverlay && filterOverlay.addEventListener("click", closeFilters);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeFilters();
  });
  window.addEventListener("resize", function () {
    if (!window.matchMedia("(max-width: 820px)").matches) closeFilters();
  });

  /* initial cart badge */
  fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { countEl && (countEl.textContent = c.item_count); });
})();
